//
// This maps spIds to their corresponding design system.
// This is used to inject the correct styles/javascript to display the microfrontend.
//
export interface GetDesignSystemForSpId {
  system: string;
  uri: string;
}

const SPID_TO_DESIGNSYSTEM: Record<string, GetDesignSystemForSpId> = {
  SP301: { system: 'occl', uri: 'https://library.telefonica.de/1' },
  SP251: { system: 'occl', uri: 'https://library.telefonica.de/1' },
  SP252: { system: 'occl', uri: 'https://library.telefonica.de/1' },
  SP299: { system: 'occl', uri: 'https://library.telefonica.de/1' },
  SP302: { system: 'occl', uri: 'https://library.telefonica.de/2' },
  SP303: { system: 'occl', uri: 'https://library.telefonica.de/65' },
  SP304: { system: 'occl', uri: 'https://library.telefonica.de/72' },
  SP602: { system: 'dsOne', uri: 'https://one.o9.de/main/fonic' },
  SP901: { system: 'dsOne', uri: 'https://one.o9.de/main/o2' },
  SP902: { system: 'dsOne', uri: 'https://one.o9.de/main/blau' },
  SP904: { system: 'dsOne', uri: 'https://one.o9.de/main/ayyildiz' },
  SP907: { system: 'dsOne', uri: 'https://one.o9.de/main/nettokom' },
  SP909: { system: 'dsOne', uri: 'https://one.o9.de/main/ortel' },
  SP910: { system: 'dsOne', uri: 'https://one.o9.de/main/whatsappsim' },
  SP912: { system: 'dsOne', uri: 'https://one.o9.de/main/alditalk' },
  SP913: { system: 'dsOne', uri: 'https://one.o9.de/main/ortel' },
};

export const getDesignSystemForSpId = (spId: string) => {
  const value = SPID_TO_DESIGNSYSTEM[spId];
  if (!value) {
    throw new Error(`No designSystem found for spId ${spId}`);
  }

  return value;
};
